import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type LoadingType = {
  requests: boolean;
  courses: boolean;
};

const initialState: LoadingType = { courses: true, requests: true };

export const loadngSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<Partial<LoadingType>>) => {
      for (let k of Object.keys(action.payload)) {
        const key = k as keyof LoadingType;
        state[key] = action.payload[key] as boolean;
      }
      return state;
    },
  },
});

export const { setLoading } = loadngSlice.actions;

export default loadngSlice.reducer;
